import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ResendEmailVerificationService {

  private readonly apiUrl = environment.apiUrl;
  http = inject(HttpClient);


  sendEmail(email: string) {
    return this.http.post(`${this.apiUrl}/email/resend`, { email });
  }



}
